import { useQuerySubscription } from "react-datocms"
import { getSubscription, queries } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import About from "@components/static/About/About"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"

const AboutPage = ({ subscription, options }) => {
  const {
    data: { seo, about },
  } = useQuerySubscription(subscription)

  return (
    <Layout options={options}>
      <Seo
        global={seo}
        title="About Us"
        description="House of Party Planning is a premium party planning platform, with a huge directory of suppliers, tools, and advice. Learn more about us and our mission."
      />
      <About {...about} />
    </Layout>
  )
}

export async function getStaticProps() {
  const graphqlRequest = {
    query: `
      {
        ${queries.seo}
        ${queries.about}
      }
    `,
  }

  const subscription = await getSubscription(graphqlRequest)

  const options = await loadOptionsData()

  return {
    props: {
      subscription,
      options,
    },
  }
}

export default AboutPage
